<!-- Translated: yes -->
<template>
  <Modal @close="localCloseModal" :wide="false" width="500px">
    <h1 v-if="params.title">{{params.title}}</h1>
    <div v-html="params.content"></div>
    <div class="center">
      <button v-if="params.yes" class="small" @click="params.yes()">
        {{ $t('general.yes') }}
      </button>
      <button v-if="params.ok" class="small" @click="params.ok()">
        {{ $t('general.okay') }}
      </button>
      <button v-if="params.no" class="small white border" @click="params.no()">
        {{ $t('general.no') }}
      </button>
      <button v-for="btn in params.buttons" :class="btn.class" @click="btn.click()">
        {{btn.title}}
      </button>
    </div>

    <component :is="this.params.embed" :config="this.params" v-if="this.params.embed" />
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
    ]),
    localCloseModal() {
      if (this.params.closeModal) {
        this.params.closeModal();
        return;
      }
      this.closeModal();
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

button
  margin-right 15px
  margin-top 15px
</style>



// WEBPACK FOOTER //
// GeneralModal.vue?564b5492